import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import createMockServer from './mock/server';
import { getConsoleLogger } from './util/logger';

const consoleLogger = getConsoleLogger('index');

if (
  process.env.NODE_ENV === 'development' &&
  window.custom_env.USE_BUREAUCRAT_MOCK === 'true'
) {
  consoleLogger.debug('making mock bureaucrat server');
  createMockServer();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
